import axiosInstance from "./axiosInstance";

export const getExcelProgress = async (projectId) => {
  const response = await axiosInstance.get(
    `/projects/${projectId}/excel-progress`
  );
  return response.data;
};
